import { useTranslation } from "react-i18next";
import { PlannerEmployee } from "@/components/appointmentRequest/assignmentPlanner/assignmentPlan";
import styles from "@/components/appointmentRequest/assignmentPlanner/planner.module.css";

interface Props {
  employee: PlannerEmployee;
  showEmail: boolean;
}
export default function PlannerEmployeeIdentity({
  employee,
  showEmail,
}: Props) {
  const { t } = useTranslation();
  const showDetails = Boolean(
    employee.worker_id || (showEmail && employee.email),
  );
  return (
    <span className={styles.employeeIdentity}>
      <span className={styles.name} title={employee.name}>
        {employee.name}
      </span>
      {showDetails && (
        <span className={styles.identityDetails}>
          {showEmail && employee.email && (
            <span
              className={styles.identityEmail}
              title={`${t("email")}: ${employee.email}`}
              aria-label={`${t("email")}: ${employee.email}`}
            >
              {employee.email}
            </span>
          )}
          {employee.worker_id && (
            <span
              className={styles.identityWorkerId}
              title={`${t("worker_id")}: ${employee.worker_id}`}
              aria-label={`${t("worker_id")}: ${employee.worker_id}`}
            >
              {employee.worker_id}
            </span>
          )}
        </span>
      )}
    </span>
  );
}
